import { Environment } from '@standardnotes/models';
/* istanbul ignore file */
export function isDesktopDevice(x) {
    return x.environment === Environment.Desktop;
}
